<template>
  <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M1 6C1 5.44772 1.44772 5 2 5C2.55228 5 3 5.44772 3 6V13C3 13.5523 2.55228 14 2 14C1.44772 14 1 13.5523 1 13V6Z"
        fill="currentColor"/>
    <path
        d="M1 1C1 0.447715 1.44772 0 2 0C2.55228 0 3 0.447715 3 1V2C3 2.55228 2.55228 3 2 3C1.44772 3 1 2.55228 1 2V1Z"
        fill="currentColor"/>
    <path
        d="M6 1C6 0.447715 6.44772 0 7 0C7.55228 0 8 0.447715 8 1V8C8 8.55228 7.55228 9 7 9C6.44772 9 6 8.55228 6 8V1Z"
        fill="currentColor"/>
    <path
        d="M6 12C6 11.4477 6.44772 11 7 11C7.55228 11 8 11.4477 8 12V13C8 13.5523 7.55228 14 7 14C6.44772 14 6 13.5523 6 13V12Z"
        fill="currentColor"/>
    <path
        d="M11 9C11 8.44772 11.4477 8 12 8C12.5523 8 13 8.44772 13 9V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V9Z"
        fill="currentColor"/>
    <path
        d="M11 1C11 0.447715 11.4477 0 12 0C12.5523 0 13 0.447715 13 1V5C13 5.55228 12.5523 6 12 6C11.4477 6 11 5.55228 11 5V1Z"
        fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M2 6C3.10457 6 4 5.10457 4 4C4 2.89543 3.10457 2 2 2C0.895431 2 0 2.89543 0 4C0 5.10457 0.895431 6 2 6ZM2 5C2.55228 5 3 4.55228 3 4C3 3.44772 2.55228 3 2 3C1.44772 3 1 3.44772 1 4C1 4.55228 1.44772 5 2 5Z"
          fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M7 12C8.10457 12 9 11.1046 9 10C9 8.89543 8.10457 8 7 8C5.89543 8 5 8.89543 5 10C5 11.1046 5.89543 12 7 12ZM7 11C7.55228 11 8 10.5523 8 10C8 9.44772 7.55228 9 7 9C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11Z"
          fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M12 9C13.1046 9 14 8.10457 14 7C14 5.89543 13.1046 5 12 5C10.8954 5 10 5.89543 10 7C10 8.10457 10.8954 9 12 9ZM12 8C12.5523 8 13 7.55228 13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7C11 7.55228 11.4477 8 12 8Z"
          fill="currentColor"/>
  </svg>

</template>

<script>
export default {
  name: "IconMoreSettings"
}
</script>

<style scoped>

</style>